import { Colors, FInter, FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "shared/pages/projectEdit/spinner";
import { useTheme } from "styled-components";
import { PageViewportLayout } from "../template";
import { useProfile } from "@brg/auth";

export const CompetitionEditFrameCreating: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {t('project_edit.frames.creating_the_competition')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <FlexBox offsetBottom={16}>
                </FlexBox>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const CompetitionEditFrameLoading: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout justify={'center'} align={'center'}>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {t('project_edit.frames.loading_competition')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const CompetitionErrorNotAllowed: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const profile = useProfile();
    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={Colors.geoWhite47}>
                {t('project_edit.frames.something_went_wrong')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('competition.frames.permissions_watch')}
            </FInter.TextFlex>
            <FInter.SmallTextDiv color={Colors.geoWhite47}>
                COMPETITION ID: {id} - PROFILE ID: {profile?.accountId ?? "None"}
            </FInter.SmallTextDiv>
        </PageViewportLayout>
    );
};import { Colors, FInter, FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "shared/pages/projectEdit/spinner";
import { useTheme } from "styled-components";
import { PageViewportLayout } from "../template";
import { useProfile } from "@brg/auth";

export const CompetitionEditFrameCreating: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {t('project_edit.frames.creating_the_competition')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <FlexBox offsetBottom={16}>
                </FlexBox>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const CompetitionEditFrameLoading: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout justify={'center'} align={'center'}>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {t('project_edit.frames.loading_competition')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const CompetitionErrorNotAllowed: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();
    const profile = useProfile();
    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <FInter.MainTitleMediumDiv color={Colors.geoWhite47}>
                {t('project_edit.frames.something_went_wrong')}
            </FInter.MainTitleMediumDiv>
            <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                {t('competition.frames.permissions_watch')}
            </FInter.TextFlex>
            <FInter.SmallTextDiv color={Colors.geoWhite47}>
                COMPETITION ID: {id} - PROFILE ID: {profile?.accountId ?? "None"}
            </FInter.SmallTextDiv>
        </PageViewportLayout>
    );
};